const Reddit = (props: { fill: string }) => {
	return (
		<>
			<path
				d="M9.22758 11.6814C8.63908 11.6814 8.13281 12.2664 8.09766 13.0286C8.0625 13.7908 8.57791 14.1009 9.16713 14.1009C9.75634 14.1009 10.1958 13.8239 10.231 13.0617C10.2661 12.2995 9.81609 11.6814 9.22758 11.6814Z"
				fill={props.fill}
			/>
			<path
				d="M15.9115 13.0286C15.8771 12.2664 15.3708 11.6814 14.7816 11.6814C14.1923 11.6814 13.7431 12.2995 13.7782 13.0617C13.8134 13.8246 14.2535 14.1009 14.842 14.1009C15.4306 14.1009 15.9466 13.7908 15.9115 13.0286Z"
				fill={props.fill}
			/>
			<path
				d="M14.2191 15.0206C14.262 14.9179 14.1916 14.8033 14.0813 14.7921C13.4337 14.7267 12.7348 14.6908 12.0042 14.6908C11.2737 14.6908 10.5741 14.7267 9.9272 14.7921C9.81682 14.8033 9.7465 14.9179 9.78938 15.0206C10.1522 15.8861 11.0065 16.4943 12.0042 16.4943C13.002 16.4943 13.857 15.8861 14.2191 15.0206Z"
				fill={props.fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3 12C3 7.02961 7.02961 3 12 3C16.9704 3 21 7.02961 21 12C21 16.9704 16.9704 21 12 21H4.3036C3.82265 21 3.58148 20.4185 3.9218 20.0782L5.63602 18.364C4.00757 16.7355 3 14.4855 3 12ZM15.2906 8.39854C14.5812 8.39854 13.9871 7.90565 13.8309 7.24402V7.24542C12.9703 7.36706 12.3066 8.10816 12.3066 9.00112V9.00675C13.639 9.05667 14.8568 9.43214 15.8215 10.0291C16.1759 9.75628 16.6196 9.59386 17.1012 9.59386C18.262 9.59386 19.2028 10.5346 19.2028 11.6955C19.2028 12.5329 18.712 13.2564 18.0026 13.5939C17.9365 16.0359 15.2745 18.0004 12.0042 18.0004C8.73399 18.0004 6.07547 16.038 6.00586 13.5982C5.2908 13.2628 4.79579 12.5371 4.79579 11.6948C4.79579 10.5339 5.73657 9.59315 6.89742 9.59315C7.38117 9.59315 7.82697 9.75698 8.18205 10.0319C9.13829 9.43917 10.3427 9.0637 11.6618 9.00815V9.00042C11.6618 7.75378 12.6089 6.72511 13.8218 6.59503C13.9624 5.91229 14.5664 5.39901 15.2906 5.39901C16.1189 5.39901 16.7904 6.0705 16.7904 6.89878C16.7904 7.72706 16.1189 8.39854 15.2906 8.39854Z"
				fill={props.fill}
			/>
		</>
	);
};

export default Reddit;
